/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useMemo } from 'react';

import { cssMap, jsx } from '@compiled/react';
import { useAtom } from 'jotai';
import { FormattedMessage } from 'react-intl';

import { token } from '@atlaskit/tokens';

import { SectionName } from '../../../../common/analytics/section-name';
import { useSectionReveal } from '../../../../common/analytics/useSectionReveal';
import { KnowledgeSourcesAtom } from '../../../state';
import { SpacingWrapper } from '../../SpacingWrapper';

import { messages } from './messages';
import { RecommendedApps } from './RecommendedApps';

const styles = cssMap({
	container: {
		maxWidth: '100%',
		paddingTop: token('space.0'),
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
		paddingBottom: '7.5rem',
		display: 'flex',
		flexDirection: 'column',
		gap: token('space.400'),
		// NO ADS token exists for 88px
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
		paddingInline: '88px',
		'@media (max-width: 30rem)': {
			paddingInline: token('space.0'),
		},
	},
});

export const ConnectorsSection = (): JSX.Element | null => {
	const [knowledgeSourcesResult] = useAtom(KnowledgeSourcesAtom);
	const { data: knowledgeSources, error: knowledgeSourcesError } = knowledgeSourcesResult;
	const sectionRef = useSectionReveal<HTMLDivElement>(SectionName.Connectors);

	const notConnectedApps = useMemo(
		() => knowledgeSources.filter((source) => !source.isUserOAuthed),
		[knowledgeSources],
	);

	// TODO GRAPHYTE-2509: handle error a bit better
	if (knowledgeSourcesError !== null && knowledgeSourcesError !== undefined) {
		return (
			<div>
				<FormattedMessage
					{...messages.loadConnectorsError}
					values={{ error: String(knowledgeSourcesError) }}
				/>
			</div>
		);
	}

	// TODO: GRAPHYTE-2515 handle no more connectors to connect
	if (notConnectedApps.length === 0) {
		// eslint-disable-next-line no-console
		console.log('no more connectors to connect');
		return null;
	}

	return (
		<SpacingWrapper>
			<div ref={sectionRef} css={styles.container}>
				<RecommendedApps notConnectedApps={notConnectedApps} />
			</div>
		</SpacingWrapper>
	);
};
